function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M75.87.48h-75v80h75v-80z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M29.71 1.02h-3.88L15.5 12.12v4.16L29.7 1.02zM15.5 17.75v4.18L34.97 1.02h-3.88L15.5 17.75zm5.08-16.73h3.88l-8.95 9.62V6.47l5.07-5.45zm19.63 0h-3.88L15.5 23.4v4.17L40.2 1.02zM15.5 29.04v4.81L46.07 1.02h-4.48L15.5 29.04zM49.9 2.53l-.65-.57a2.5 2.5 0 00-1.84-.92L15.5 35.32v4.17L49.9 2.53zM15.5 40.96v4.81L53.08 5.41l-2.04-1.88-.38-.33L15.5 40.96zM55.9 8l-2.1-1.92-38.3 41.16v4.17l40.4-43.4zM15.5 52.88v.05c0 1.27.63 2.39 1.58 3.07l41.65-44.75c-.16-.5-.42-.96-.77-1.36l-1.32-1.2-41.13 44.2zM58.9 16.7l.01-4.18-40.9 43.96c.39.15.82.23 1.27.23h2.4l37.22-40zm-35.86 40h3.89l31.95-34.33.01-4.19-35.85 38.53zM19.21 1.02h-.23c-2.08 0-3.47.16-3.47 2.24V5l3.7-3.98zM32.18 56.7h-3.89l30.58-32.85-.01 4.19L32.18 56.7zm1.36 0h3.89l21.4-23 .02-4.2-25.3 27.2zm9.14 0H38.8l20.03-21.53-.01 4.2L42.68 56.7zm1.37 0h3.88L58.8 45.03l.01-4.19-14.76 15.88zm9.13 0H49.3l9.5-10.2-.02 4.19-5.6 6.02zm1.37 0H55a3.77 3.77 0 003.77-3.76v-.78l-4.22 4.55z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#959DAC",
  strokeWidth: 0.5,
  d: "M48.18 1.28v3.1m0 1.47v2.92c0 .53.16 1.02.45 1.4m4.51.8h-2.93c-.29 0-.56-.06-.8-.17m5.1.17h4.12M29.7 1.02h-3.88L15.5 12.12v4.16L29.7 1.02zM15.5 17.75v4.18L34.96 1.02h-3.88L15.5 17.75zm8.95-16.73h-3.88L15.5 6.47v4.17l8.95-9.62zm11.87 0h3.88L15.5 27.57V23.4L36.33 1.02zM15.5 33.85v-4.81L41.58 1.02h4.48L15.5 33.85zM49.25 1.96l.65.57L15.5 39.5v-4.17L47.4 1.04a2.5 2.5 0 011.85.92zM15.51 45.77v-4.81L50.65 3.2l.38.33 2.04 1.88L15.5 45.77zM53.8 6.08l2.09 1.93-40.4 43.4v-4.17L53.8 6.08zM15.5 52.93v-.05l41.13-44.2 1.32 1.21c.35.4.61.86.77 1.36L17.08 56a3.77 3.77 0 01-1.57-3.07zm43.4-40.41l-.01 4.19-37.22 40h-2.4c-.45 0-.88-.08-1.28-.23L58.9 12.52zM26.93 56.7h-3.89L58.9 18.18l-.01 4.2L26.93 56.7zM18.98 1.02h.23L15.51 5V3.26c0-2.08 1.39-2.24 3.47-2.24zm9.31 55.69h3.89l26.68-28.67.01-4.2L28.3 56.72zm9.14 0h-3.89l25.31-27.2-.01 4.19-21.41 23zm1.37 0h3.88l16.14-17.35.01-4.19L38.8 56.71zm9.13 0h-3.88L58.8 40.83l-.01 4.2L47.93 56.7zm1.37 0h3.88l5.6-6.02.01-4.2-9.5 10.22zm5.7 0h-.45l4.23-4.55v.78A3.79 3.79 0 0155 56.71z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1054B8",
  stroke: "#1F487E",
  d: "M53.47 6.17h0l2.93 2.65h0l1.31 1.19.4.66-8.12.03a1.5 1.5 0 01-1.5-1.47l-.08-3.28V1.6l.03.01 2.24 1.99 2.79 2.57z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M37.83 7.94v10.74a2.42 2.42 0 002.42 2.42h10.06m-6.79-8.69l-3.18-3.44a4.23 4.23 0 00-3.1-1.36H6.26a4.23 4.23 0 00-4.23 4.23v55.67c0 2.34 1.9 4.23 4.23 4.23H46.3a4.23 4.23 0 004.23-4.21l.15-45.43c0-1.05-.38-2.05-1.07-2.83l-6.1-6.86z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#595A5B",
  strokeWidth: 0.5,
  d: "M37.83 7.94v10.74a2.42 2.42 0 002.42 2.42h10.06m-6.79-8.69l-3.18-3.44a4.23 4.23 0 00-3.1-1.36H6.26a4.23 4.23 0 00-4.23 4.23v55.67c0 2.34 1.9 4.23 4.23 4.23H46.3a4.23 4.23 0 004.23-4.21l.15-45.43c0-1.05-.38-2.05-1.07-2.83l-6.1-6.86z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#595A5B",
  strokeLinecap: "round",
  d: "M35.53 44.2H19.36m16.17 12.5H21.46"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFE068",
  strokeLinecap: "round",
  d: "M19.36 56.7H11.4m5.87-12.5h-5.78m24.22 6.61h-6.16"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#595A5B",
  strokeLinecap: "round",
  d: "M27.85 50.81H15.97"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFE068",
  strokeLinecap: "round",
  d: "M14.15 50.81H11.3"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#595A5B",
  strokeLinecap: "round",
  d: "M11.47 25.37h16.17m-16.17 12.5h14.07"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFE068",
  strokeLinecap: "round",
  d: "M27.64 37.87h7.96m-5.87-12.5h5.78m-24.22 6.61h6.15"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#595A5B",
  strokeLinecap: "round",
  d: "M19.15 31.98h11.88"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFE068",
  strokeLinecap: "round",
  d: "M32.84 31.98h2.87"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#1F487E",
  filter: "url(#filter0_d_1770_15331)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1054B8",
  d: "M63.07 32.26H44.1a7.5 7.5 0 00-7.5 7.5v24.56a7.5 7.5 0 007.5 7.5h18.97a7.5 7.5 0 007.5-7.5V39.76a7.5 7.5 0 00-7.5-7.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  strokeWidth: 0.5,
  d: "M65.63 38.36H41.54c-.96 0-1.75.78-1.75 1.75v2.36c0 .97.79 1.75 1.75 1.75h24.1c.96 0 1.74-.78 1.74-1.75v-2.36c0-.97-.78-1.75-1.75-1.75zM46.07 50.02h-5a1.5 1.5 0 100 2.99h5a1.5 1.5 0 100-3zm9.79 0h-5a1.5 1.5 0 100 2.99h5a1.5 1.5 0 100-3zm9.8 0h-5a1.5 1.5 0 100 2.99h5a1.5 1.5 0 000-3zm-19.59 6h-5a1.5 1.5 0 000 2.99h5a1.5 1.5 0 100-3zm9.79 0h-5a1.5 1.5 0 000 2.99h5a1.5 1.5 0 100-3zm9.8 0h-5a1.5 1.5 0 000 2.99h5a1.5 1.5 0 000-3zm-19.59 5.99h-5a1.5 1.5 0 100 3h5a1.5 1.5 0 100-3zm9.79 0h-5a1.5 1.5 0 100 3h5a1.5 1.5 0 100-3zm9.8 0h-5a1.5 1.5 0 100 3h5a1.5 1.5 0 000-3z"
})));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1770_15331"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h75v80H0z",
  transform: "translate(.865 .484)"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_1770_15331",
  width: 42.971,
  height: 48.56,
  x: 32.102,
  y: 31.762,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1770_15331"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1770_15331",
  result: "shape"
})));

function SvgDocumentWithCalculator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 81,
    fill: "none",
    viewBox: "0 0 76 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1770_15331)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    width: 76,
    height: 81,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, _ref2), _ref3), _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentWithCalculator);
export default __webpack_public_path__ + "static/media/document-with-calculator.790b1a72.svg";
export { ForwardRef as ReactComponent };